
import $ from 'jquery';
import Headroom from "headroom.js";

export default class Header {
    constructor() {
        this.$el = $('#js-header');
        this.$main = $('#js-main');
        this.headroom = null;
        this.debounceTime = 200;
        this.sectionAttr = 'data-menu-highlight-section';
        this.sections = $(`[${this.sectionAttr}]`);

        $(window)
            .on('scroll', this.handleScroll)
        ;

        $(document).on('click', '.js-menu-link', this.handleMenuChoice)
    }

    handleScroll = () => {
        const scrollY = $(window).scrollTop() + this.$el.outerHeight();
        const highlightedClassName = 'is-highlighted';

        this.sections.each((_, section) => {
            const sectionHeight = section.offsetHeight;
            const sectionTop = section.offsetTop - 100;
            const sectionId = section.getAttribute(this.sectionAttr);
            const currentLink = $(`a[href="#${sectionId}"]`, this.$el);

            if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
                currentLink.addClass(highlightedClassName)
            } else {
                currentLink.removeClass(highlightedClassName)
            }
        })
    }

    handleMenuChoice = () => {
        window.bootstrap
            ?.Offcanvas.getInstance($('#js-menu')?.get(0))
            ?.hide()        
    };

    init() {
        if (!this.headroom) {
            this.headroom  = new Headroom(this.$el.get(0), {
                classes : {
                    initial : 'header',
                    pinned : 'header-pinned',
                    unpinned : 'header-unpinned',
                    top : 'header-top',
                    notTop : 'header-not-top',
                    bottom : 'header-bottom',
                    notBottom : 'header-not-bottom',
                    frozen: 'header-frozen'
                },
            });  
            this.headroom.init();
        }
    }
}